import { render, staticRenderFns } from "./CategoriesBar.vue?vue&type=template&id=52794a3c&scoped=true&"
import script from "./CategoriesBar.vue?vue&type=script&lang=js&"
export * from "./CategoriesBar.vue?vue&type=script&lang=js&"
import style0 from "./CategoriesBar.vue?vue&type=style&index=0&id=52794a3c&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52794a3c",
  null
  
)

export default component.exports